import { camelCase, invert } from 'lodash';
import { 
  camelizeKeys,
  snakelizeKeys,
  makePostRequestCreator,
} from 'common';

import { 
  SortOrderMap,
  ListDisplayPreferences, 
  CommonDisplayPreferences,
} from '../constants';


const axiosRepeat = makePostRequestCreator();

export const getReportCallLog = async (params) => {
  try {
    const { url, ...others } = params;
    const { data } = await axiosRepeat(url, snakelizeKeys(others));
    return normalizeCustomReport(camelizeKeys(data));
  } catch (e) {
    return e;
  }
};

export const sendReportCallLogToEmail = async (params) => {
  try {
    const { data } = await axiosRepeat(
      '/v2/nextos/reports/call-log-csv',
      snakelizeKeys(params),
    );
    return data;
  } catch (e) {
    return e;
  }
};

export function normalizeCustomReport(data) {
  const {
    limit,
    offset,
    totalCount,
    tables: [table],
  } = data;

  return {
    pagination: {
      limit,
      offset,
      totalItems: totalCount,
    },
    sortData: {
      key: camelCase(table.sort.header),
      order: invert(SortOrderMap)[table.sort.order],
    },
    table: {
      rows: table.rows,
      headers: table.headers.map(column => {
        const name = camelCase(column.id);
        return {
          name,
          value: name,
          label: column.label,
          duration: Boolean(column.duration),
          sortable: Boolean(column.sortable),
          ...CommonDisplayPreferences,
          ...ListDisplayPreferences[name],
        }
      }),
    },
  };
}
